var map = {
	"./orientation-horizontal-off.svg": "1a4b",
	"./orientation-horizontal-on.svg": "88bd",
	"./orientation-horizontal.svg": "68f7",
	"./orientation-vertical-off.svg": "1437",
	"./orientation-vertical-on.svg": "09de",
	"./orientation-vertical.svg": "694b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5faa";